(function () {
  if (window.__poeticThumbDrag) return;
  window.__poeticThumbDrag = true;

  function initSlider(slider) {
    if (!slider || slider.dataset.dragScrollInit) return;
    slider.dataset.dragScrollInit = '1';

    let down = false;
    let axis = 'x';
    let start = 0;
    let startScroll = 0;
    let moved = false;

    const onMove = (e) => {
      if (!down) return;
      const delta = (axis === 'x' ? e.pageX : e.pageY) - start;
      if (Math.abs(delta) > 3) moved = true;
      if (axis === 'x') {
        slider.scrollLeft = startScroll - delta;
      } else {
        slider.scrollTop = startScroll - delta;
      }
    };

    const end = () => {
      if (!down) return;
      down = false;
      slider.classList.remove('is-dragging');
      window.removeEventListener('pointermove', onMove);
      window.removeEventListener('pointerup', end);
      window.removeEventListener('pointercancel', end);
    };

    slider.addEventListener('pointerdown', (e) => {
      // Leave touch to native scrolling; only drive drag with mouse/pen.
      if (e.pointerType === 'touch') return;
      const canX = slider.scrollWidth - slider.clientWidth;
      const canY = slider.scrollHeight - slider.clientHeight;
      if (canX <= 0 && canY <= 0) return;
      axis = canX >= canY ? 'x' : 'y';
      down = true;
      moved = false;
      start = axis === 'x' ? e.pageX : e.pageY;
      startScroll = axis === 'x' ? slider.scrollLeft : slider.scrollTop;
      slider.classList.add('is-dragging');
      // Track the drag on window rather than setPointerCapture: capturing the
      // pointer on the <ul> makes Chrome retarget the follow-up click to the
      // <ul>, so the thumbnail button's click never fires and the featured
      // media won't switch. Window listeners keep fast off-element drags working.
      window.addEventListener('pointermove', onMove);
      window.addEventListener('pointerup', end);
      window.addEventListener('pointercancel', end);
    });

    // Stop the browser's native image drag so a mouse drag scrolls instead.
    slider.addEventListener('dragstart', (e) => e.preventDefault());

    // Swallow the click that ends a real drag so it doesn't switch the featured
    // image; a plain click (no movement) passes through to select the thumbnail.
    slider.addEventListener(
      'click',
      (e) => {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
          moved = false;
        }
      },
      true
    );

    // Wheel-to-scroll for the horizontal strip. SliderComponent blocks
    // horizontal-intent wheel events, so map the wheel delta to scrollLeft here.
    // The vertical thumbnail_left layout keeps its native wheel scrolling.
    slider.addEventListener(
      'wheel',
      (e) => {
        const canX = slider.scrollWidth - slider.clientWidth;
        const canY = slider.scrollHeight - slider.clientHeight;
        if (canX <= 1 || canY > canX) return;
        const delta = Math.abs(e.deltaX) >= Math.abs(e.deltaY) ? e.deltaX : e.deltaY;
        if (!delta) return;
        slider.scrollLeft += delta;
        e.preventDefault();
      },
      { passive: false }
    );
  }

  function initAll(root) {
    (root || document)
      .querySelectorAll('products-thumbnail-slider [id^="Slider-Thumbnails"]')
      .forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();
